module.exports = __webpack_public_path__ + "static/img/d9t_pc.4a43269d.jpg";